function resin(state={}, action){
  return state;
}

export default resin;

export function getDefaultCore(state){
  return state.cores[0];
}

export function getDefaultPrepreg(state){
  return {
    count: 1,
    material: state.prepregs[0]
  };
}

export function getCores(state) {
  return state.cores;
}

export function getPrepregs(state) {
  return state.prepregs.map(p => ({ count: 1, material: p }));
}



// WEBPACK FOOTER //
// ./src/reducers/resins/resin.js